// src/config/gridColumns.ts
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Box, Button, CircularProgress } from '@mui/material';
import { SampleSchema } from '@/zod_schemas';

interface GetSampleColumnsProps {
  deleteAction?: boolean;
  onClickDelete?: (id: string, name: string) => void;
  deletingRowId?: string | null;
  isDeleting?: boolean;
}

export const getSampleColumns = ({
  deleteAction = false,
  onClickDelete,
  deletingRowId,
  isDeleting = false,
}: GetSampleColumnsProps): GridColDef<SampleSchema>[] => {
  const columns: GridColDef<SampleSchema>[] = [
    {
      field: 'sample_id',
      headerName: 'Sample ID',
      flex: 1,
    },
    {
      field: 'files',
      headerName: 'Files',
      flex: 1,
      renderCell: (params) =>
        params.row.files.map((file) => file.file_path).join(', '),
      // renderCell: (params) => (
      //   <Box sx={{ whiteSpace: 'pre-line' }}>{params.value.join('\n')}</Box>
      // ),
    },
  ];

  if (deleteAction) {
    columns.push({
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      flex: 0.8,
      renderCell: (params: GridRenderCellParams<SampleSchema>) => {
        const rowId = String(params.row.id ?? params.row.id ?? '');
        const rowName = String(params.row.id ?? params.row.sample_id ?? rowId);

        const isThisRowDeleting = deletingRowId === rowId;

        return (
          <Box>
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => {
                if (!rowId) return;
                onClickDelete?.(rowId, rowName);
              }}
              disabled={isDeleting || !rowId}
              startIcon={
                isThisRowDeleting ? (
                  <CircularProgress size={16} color="inherit" />
                ) : null
              }
              sx={{ ml: 1 }}
            >
              {isThisRowDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          </Box>
        );
      },
      // renderCell: (params) => (
      //   <Box>
      //     <Button
      //       variant="contained"
      //       color="error"
      //       size="small"
      //       onClick={() => {
      //         const rowParams = params.row.id;
      //         if (patientId && onRemoveSamplePatients) {
      //           onRemoveSamplePatients([rowParams!]);
      //         }
      //       }}
      //       style={{ marginLeft: 8 }}
      //     >
      //       Delete
      //     </Button>
      //   </Box>
      // ),
    });
  }

  // if (selectAction) {
  //   columns.push({
  //     field: 'actions2',
  //     headerName: 'Actions2',
  //     sortable: false,
  //     flex: 0.8,
  //     renderCell: (params) => (
  //       <Box>
  //         <Button
  //           variant="contained"
  //           color="primary"
  //           size="small"
  //           onClick={() => {
  //             if (patientId && onAssignSampleToPatient) {
  //               onAssignSampleToPatient([params.row.id!]);
  //             }

  //             if (setDialogOpen) {
  //               setDialogOpen(false);
  //             }
  //           }}
  //           style={{ marginLeft: 8 }}
  //         >
  //           Select
  //         </Button>
  //       </Box>
  //     ),
  //   });
  // }

  return columns;
};
